import React from 'react';
import { classNames } from '../../utils/style';
import Check from '../../assets/images/check.svg';
import Cross from '../../assets/images/cross.svg';

import { ComparisonTableHeaderProps } from './Header';
import { ComparisonTableRow } from './Table';

export interface ComparisonTableBodyProps extends ComparisonTableHeaderProps {
  data: ComparisonTableRow[];
  isSmall?: boolean;
  offers?: any[];
}

export const Body = ({
  className,
  data,
  headers,
  offers,
  isSmall,
}: ComparisonTableBodyProps) => {
  return (
    <table className="w-full">
      <tbody
        className={classNames('ComparisonTableBody flex flex-col', className)}
      >
        {data.map((row, key) => (
          <tr
            key={key}
            className={classNames(
              'border-b',
              'flex flex-row justify-end',
              'border-b border-blue-51 last:border-none',
            )}
          >
            <td className="w-auto flex-1 p-16 text-neutral-301">
              {row.rowLabel}
            </td>
            {headers.map((header, i) => {
              return (
                <td
                  key={i}
                  className={classNames(
                    'w-40 p-[11px] py-16 text-neutral-301',
                    !isSmall && 'md:w-[130px] lg:w-[180px] xl:w-[198px]',
                    offers?.[i]?.highlightedLabel && 'highlighted',
                  )}
                >
                  <div
                    className={classNames(
                      'flex w-full items-center',
                      'h-full justify-center',
                    )}
                  >
                    {header in row.values && row.values[header] ? (
                      <Check className="h-[14px] w-[18px]" />
                    ) : (
                      <Cross className="cross h-[27px] w-auto" />
                    )}
                  </div>
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
